export default __webpack_public_path__ + "static/media/aragon.89569502.png";